import { ref, computed } from "vue";
import { defineStore } from "pinia";
import axios from "axios";
import moment from "moment";
import Ajax from "../../utilities/ajax";

const defaultConfig = {
  isActive: false,
  isBannerActive: true,
  isWelcomeActive: true,
};

const defaultPayload = {
  step: 0,
};

const useChatWidget = defineStore("chatWidget", () => {
  const globalSettings = ref(prebook || {});
  const settings = ref(prebook_chat_widget.settings || {});
  const config = ref({
    ...defaultConfig,
    isActive: settings.value.customizer.settings.widget_view,
  });

  const payload = ref({ ...defaultPayload });
  const services = ref([]);
  const staffs = ref([]);
  const availableDates = ref([]);
  const availableSlots = ref([]);

  const getGlobalSettings = () => {
    return globalSettings.value;
  };

  const fetchGlobalSettings = async (section = null) => {
    const response = await Ajax.get("get_settings", { section });
    window.prebook.settings = response.data;
  };

  const getConfig = computed(() => {
    return config.value;
  });

  const updateConfig = (value) => {
    config.value = value;
  };

  const getSettings = computed(() => {
    return settings.value;
  });

  const getCustomizer = computed(() => {
    return settings.value.customizer;
  });

  const getPayload = () => {
    return payload.value;
  };

  const updatePayload = (value) => {
    payload.value = value;
  };

  const getServices = () => {
    if (payload.value?.staff?.staff_id) {
      const staff_id = payload.value?.staff?.staff_id;
      return services.value.filter((service) => {
        return service.staffs.includes(staff_id);
      });
    }
    return services.value;
  };

  const getStaffs = () => {
    if (payload.value?.service?.staffs) {
      const staff_ids = payload.value?.service?.staffs;
      return staffs.value.filter((staff) => {
        return staff_ids.includes(staff.staff_id);
      });
    }
    return staffs.value;
  };

  const fetchServices = async () => {
    const response = await axios.get(
      prebook_chat_widget.url.ajax +
        `?action=prebook_get_services&nonce=${prebook_chat_widget.admin_nonce}`,
      {
        headers: {
          "X-WP-Nonce": prebook_chat_widget.admin_nonce,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status == 200) {
      services.value = response.data.data.services;
      return true;
    }

    return false;
  };

  const fetchStaffs = async () => {
    const response = await axios.get(
      prebook_chat_widget.url.ajax +
        `?action=prebook_get_staffs&nonce=${prebook_chat_widget.admin_nonce}`,
      {
        headers: {
          "X-WP-Nonce": prebook_chat_widget.admin_nonce,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status == 200) {
      staffs.value = response.data.data;
      return true;
    }

    return false;
  };

  const prepareParams = () => {
    let pageUrl = window.location.href.split("#")[0];
    pageUrl = pageUrl.split("?")[0];

    let booking_date = new Date(payload.value.date);
    booking_date = `${booking_date.getFullYear()}-${
      booking_date.getMonth() + 1
    }-${booking_date.getDate()}`;

    return {
      customer_id: globalSettings.value.customer.customer_id,
      service_id: payload.value.service.service_id,
      staff_id: payload.value.staff.staff_id,
      booking_date: booking_date,
      booking_time_start: payload.value.time.start,
      booking_time_end: payload.value.time.end,
      appointment_type: "Onsite",
      payment_method: "cash",
      meta: {
        customer_first_name: globalSettings.value.customer.first_name,
        customer_last_name: globalSettings.value.customer.last_name,
        customer_phone: globalSettings.value.customer.customer_id,
        customer_email: globalSettings.value.customer.email,
      },
      stripe_success_url: pageUrl + "#confirmation?prebook_payment=success",
      stripe_cancel_url: pageUrl + "#confirmation?prebook_payment=cancel",
      action: "prebook_book_appointment",
      nonce: prebook_chat_widget.admin_nonce,
    };
  };

  const publish = async () => {
    const params = prepareParams();
    // console.log(params);
    const response = await Ajax.post("book_appointment", params);
  };

  const getAvailableDates = () => {
    return availableDates.value.map((date) => {
      if (date.available > 0) {
        return date.date;
      }
    });
  };

  const fetchAvailableDates = async () => {
    const params = {
      service_id: payload.value.service?.service_id,
      staff_id: payload.value.staff?.staff_id,
      max_days: 90,
    };

    const response = await Ajax.get("get_available_dates", params);

    if (response.status == 200) {
      return;
    }

    if (response.success == false) {
      return;
    }

    return (availableDates.value = response.data.filter((date) =>
      moment(date.date, "YYYY-MM-DD").isSameOrAfter(moment(), "day")
    ));
  };

  const getAvailableSlots = () => {
    return availableSlots.value;
  };

  const fetchAvailableSlots = async () => {
    const params = {
      service_id: payload.value.service?.service_id,
      staff_id: payload.value.staff?.staff_id,
      customer_id: globalSettings.value.customer.customer_id,
      date: moment(payload.value.date).format("YYYY-MM-DD"), // Format date to YYYY-MM-DD
    };

    const response = await Ajax.get("get_available_slots", params);

    if (response.status == 200) {
      return;
    }

    if (response.success == false) {
      return;
    }

    return (availableSlots.value = response.data);
  };

  return {
    getGlobalSettings,
    fetchGlobalSettings,
    defaultConfig,
    getConfig,
    updateConfig,
    getSettings,
    getCustomizer,
    getPayload,
    updatePayload,
    getServices,
    fetchServices,
    getStaffs,
    fetchStaffs,
    publish,
    getAvailableDates,
    fetchAvailableDates,
    getAvailableSlots,
    fetchAvailableSlots,
  };
});

export default useChatWidget;
